import React, { useSyncExternalStore } from "react";
import { useLocation } from "react-router";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";
import { useIsDesignV2 } from "../../hooks/useIsDesignV2";
import { useAppSelector } from "../../redux/store/store";
import { isStickyFooterBannerRoute } from "../../helpers/stickyFooterBannerRoutes";
import {
  getStickyFooterBannerSuppressed,
  subscribeStickyFooterBannerSuppressed,
} from "../../helpers/stickyFooterBannerVisibility";
import StickyFooterBrazeBanner from "./StickyFooterBrazeBanner";
import styles from "./StickyFooterBrazeBannerMobile.module.scss";

/**
 * Persistent fixed footer Braze host (Routes-level).
 * Sits above the bottom nav; per-page BottomMenu stays unchanged.
 */
const StickyFooterBrazeBannerMobile: React.FC = () => {
  const location = useLocation();
  const isMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2();
  const showCart = useAppSelector((state) => state.cart.showCart);
  const stickyFooterSuppressed = useSyncExternalStore(
    subscribeStickyFooterBannerSuppressed,
    getStickyFooterBannerSuppressed
  );

  if (!isMobile || !isDesignV2) return null;

  const placementActive =
    isStickyFooterBannerRoute(location.pathname) &&
    !showCart &&
    !stickyFooterSuppressed;

  return (
    <div
      className={`${styles.host} ${placementActive ? "" : styles.hostHidden}`}
      aria-hidden={!placementActive}
    >
      <StickyFooterBrazeBanner placementActive={placementActive} />
    </div>
  );
};

export default StickyFooterBrazeBannerMobile;
